import React, {useContext} from "react";
import { useLocation } from 'react-router-dom'
import Context from '../context/context';


import Login from './login'
import ForgotPassword from './forgotPassword'

import FormClassica from './formClassica'
import FormSoloRegioneAutologin from './formSoloRegione'
import FormHomepage from './formHomepage'

import FormAutoSignupExternalEmail from './formAutoSignupExternalEmail'


export default function SignupForm(props) {
	const  context = useContext(Context)


	var location = useLocation();
	location = location.pathname.split("/")



	if(location[1]==='find' || location[1] === "ms"){
		return(
			<div>
			{context.tipoHomeForm === "registrazione" && <FormClassica {...props}/>}
			{context.tipoHomeForm === "login" && <Login {...props}/>}
			{context.tipoHomeForm === "lostPassword" && <ForgotPassword {...props}/>}
		  </div>
		)
	  }
	if(location[1] == "asignup"){
		return(
			<div>
				{context.tipoHomeForm === "registrazione" && <FormSoloRegioneAutologin {...props}/>}
			</div>
		)
	}
	if(location[1] == "external_email"){
		return(
			<div>
				{context.tipoHomeForm === "registrazione" && <FormAutoSignupExternalEmail {...props}/>}
			</div>
		)
	}
	if(location[1] == "signup"){
		return(
			<div>
				{context.tipoHomeForm === "registrazione" && <FormHomepage {...props}/>}
			</div>
		)
	}
	
	else{
		return(
			<div>
				{context.tipoHomeForm === "registrazione" && <FormHomepage {...props}/>}
				{context.tipoHomeForm === "login" && <Login {...props}/>}
				{context.tipoHomeForm === "lostPassword" && <ForgotPassword {...props}/>}
			</div>
		)
	}
	
}